
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import OurFleet from '@pages/our-fleet/Index';
import { NextSeo } from 'next-seo';

export default function Index() {
  return (
    <div>
      <NextSeo
        title="Birmingham & Solihull’s Largest Private Hire Taxi Base"
        description="247 Radio Cars boasts a large fleet of vehicles that can fulfil the travel needs for any journey or event. From new modern private taxis to executive cars and wedding limousines, we have it all. Each one of our vehicles is kept in perfect condition with the goal that you just ever encounter a trip in entire peace, style and security."
        openGraph={{
          url: 'https://www.247radiocarz.co.uk/our-fleet',
        }}
        canonical="https://www.247radiocarz.co.uk/our-fleet"
      />
      <OurFleet />
    </div>
  );
}
